var exports = {
  "kL": "x43aef4ae--d885ae--container",
  "wN": "x43aef4ae--d885ae--container--orange",
  "DD": "x43aef4ae--d885ae--title",
  "h_": "x43aef4ae--d885ae--description",
};

module.exports = exports;
